import { webFonts } from "@/utils/fonts";
import { tabProps } from "@/utils/globalPropsTypes";
import { Form, Input } from "antd";
import ImageResize from "quill-image-resize-module-react";
import React from "react";
import ReactQuill, { Quill } from "react-quill-new";

window.Quill = Quill;
const Font = Quill.import("formats/font");
Font.whitelist = webFonts;
Quill.register(Font, true);

Quill.register("modules/imageResize", ImageResize, true);

const Size = Quill.import("formats/size");
Size.whitelist = [false, ...Array.from({ length: 101 }, (_, i) => `${i}px`)];
Quill.register(Size, true);

function EditorTab({ editItem }) {
  const { component } = editItem;
  // quill

  // useEffect(() => {
  // }, []);

  return (
    <>
      {["textBox"].includes(component) && (
        <Form.Item name="description" label="Description">
          <ReactQuill
            modules={descriptionModules}
            theme="snow"
            // defaultValue={{ size: "16px" }}
            // formats={{
            //   size: ["16px"],
            // }}
          />
        </Form.Item>
      )}

      {["html"].includes(component) && (
        <Form.Item name="description" label="Description">
          <Input.TextArea placeholder="Custom HTML" rows={5} />
        </Form.Item>
      )}
    </>
  );
}

export default EditorTab;

const descriptionModules = {
  toolbar: [
    [{ font: Font.whitelist }],
    [{ size: Size.whitelist }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    // [{ script: "sub" }, { script: "super" }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    // [{ direction: "rtl" }],
    [{ align: [] }],
    ["link", "image"],
    ["clean"],
  ],
  imageResize: {
    // parchment: Parchment,
    modules: ["Resize", "DisplaySize"],
  },
  clipboard: {
    matchVisual: false,
  },
};

// document.addEventListener("DOMContentLoaded", () => {
//   console.log("DOMContentLoaded");
//   try {
//     document.querySelector(".ql-picker-label").setAttribute("data-value", "18px");

//     const quill = new Quill(".quill-container", {
//       modules: descriptionModules,
//       theme: "snow",
//     });

//     quill.on("editor-change", (eventName) => {
//       if (eventName === "text-change") {
//         try {
//           // Handle text change events, such as removing an image
//         } catch (error) {
// flare.report(error);
//           // eslint-disable-next-line no-console
//           console.error("Error handling text change event:", error);
//         }
//       }
//     });
//   } catch (error) {
// flare.report(error);
//     // eslint-disable-next-line no-console
//     console.error("Error initializing Quill editor:", error);
//   }
// });

EditorTab.propTypes = tabProps;
